<template>
  <div class="teacher-consent-wrap">
    <main class="screen" role="main">

      <div class="header">
        <button
          type="button"
          class="back-button"
          aria-label="Zurück"
          @click="$router.push('/consent/age')"
        >←</button>
      </div>

      <div class="intro">
        <p class="intro-eyebrow">Lehrperson-Modus</p>
        <h1 class="intro-title">Bestätigung Lehrperson</h1>
        <p class="intro-text">
          Bitte bestätigen Sie die elterlichen Einverständnisse für die
          teilnehmenden Schülerinnen und Schüler.
        </p>
      </div>

      <div class="form-row">
        <label for="teacher-name">Name der Lehrperson</label>
        <input
          type="text"
          id="teacher-name"
          placeholder="Vorname Nachname"
          v-model="teacherName"
        >
      </div>

      <div class="form-row-inline">
        <div class="form-row">
          <label for="class-id">Klasse</label>
          <input
            type="text"
            id="class-id"
            placeholder="z.B. 7a"
            v-model="classId"
          >
        </div>
        <div class="form-row">
          <label for="student-count">Anzahl Schüler/innen</label>
          <input
            type="text"
            id="student-count"
            placeholder="z.B. 18"
            inputmode="numeric"
            v-model="studentCount"
          >
        </div>
      </div>

      <label class="consent-checkbox" for="consent-parental">
        <input type="checkbox" id="consent-parental" v-model="consentParental">
        <span class="consent-text">
          Ich bestätige, dass für alle teilnehmenden Schülerinnen und Schüler
          unter 15 Jahren das elterliche Einverständnis vorliegt.
        </span>
      </label>

      <label class="consent-checkbox" for="consent-data">
        <input type="checkbox" id="consent-data" v-model="consentData">
        <span class="consent-text">
          Ich bestätige, dass die Schulleitung über die Teilnahme informiert
          ist und die anonyme Datenauswertung zu Forschungszwecken an der BFH
          zugestimmt hat.
        </span>
      </label>

      <div class="footer">
        <button
          type="button"
          class="next-button"
          :disabled="!canStart"
          @click="startQuiz"
        >Quiz starten</button>
      </div>

    </main>
  </div>
</template>

<script>
export default {
  name: 'ChildTeacherConsent',
  data() {
    return {
      teacherName: '',
      classId: '',
      studentCount: '',
      consentParental: false,
      consentData: false,
    };
  },
  computed: {
    canStart() {
      return (
        this.teacherName.trim().length > 0 &&
        this.classId.trim().length > 0 &&
        this.studentCount.trim().length > 0 &&
        this.consentParental &&
        this.consentData
      );
    },
  },
  methods: {
    startQuiz() {
      if (this.canStart) this.$router.push('/quiz/vanilla/a');
    },
  },
};
</script>

<style scoped>
.teacher-consent-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.teacher-consent-wrap *,
.teacher-consent-wrap *::before,
.teacher-consent-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.intro {
  margin-bottom: 1.5rem;
}

.intro-eyebrow {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 8px;
}

.intro-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 12px;
  line-height: 1.25;
}

.intro-text {
  font-size: 15px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.6;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 1rem;
}

.form-row label {
  font-size: 13px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.form-row input[type="text"] {
  width: 100%;
  padding: 12px 14px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  background: var(--color-bg-card);
  color: var(--color-text-primary);
}

.form-row input[type="text"]:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px var(--color-accent-light);
}

.form-row-inline {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 1.25rem;
}

.form-row-inline .form-row {
  margin-bottom: 0;
  min-width: 0;
}

.consent-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  background: var(--color-bg-card);
  margin-bottom: 12px;
  transition: background 0.15s, border-color 0.15s;
}

.consent-checkbox:hover {
  background: var(--color-bg-muted);
}

.consent-checkbox:has(input:checked) {
  border-color: var(--color-accent);
  background: var(--color-accent-light);
}

.consent-checkbox input[type="checkbox"] {
  margin: 2px 0 0 0;
  width: 18px;
  height: 18px;
  accent-color: var(--color-accent);
  flex-shrink: 0;
}

.consent-text {
  font-size: 14px;
  color: var(--color-text-primary);
  line-height: 1.5;
}

.footer {
  margin-top: auto;
  padding-top: 1rem;
}

.next-button {
  width: 100%;
  padding: 14px;
  background: var(--color-bg-muted);
  color: var(--color-text-tertiary);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: not-allowed;
}

.next-button:not(:disabled) {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
  cursor: pointer;
}

.next-button:not(:disabled):hover {
  opacity: 0.9;
}
</style>
